

























































import isSameDay from 'date-fns/isSameDay';
import format from 'date-fns/format';
import Vue from 'vue';

// Models
import { VFair } from '~/services/types/vfair';
import { IS_PROD } from '~/router';
import URLS from '~/URLS';

// Constants
const VFAIR_ID_PROD = '3aa5fe34-f5a3-4341-8f77-20967860eb20';
const VFAIR_ID_STAGING = 'f791908d-c8cb-4537-87eb-0a4892d4ddca';
const VFAIR_ID_TEST = 'f791908d-c8cb-4537-87eb-0a4892d4ddca';

// Types
interface ConferenceDay {
    videoId: string;
    title: string;
    time: number;
}

interface ConferenceConfig {
    days: ConferenceDay[];
}

// NOTE: This implementation is just a temporarly hack atm. Logic for 'conference' need to be reimplemented in the future.
export default Vue.extend({
    name: 'VFairConference',
    props: {
        vfair: {
            type: Object as () => { data: VFair },
            required: true,
        },
    },
    data: () => ({
        isInitialized: false,
        domain: window.location.hostname,
        link: 'https://highered.global/conference',

        config: null as ConferenceConfig | null,
        activeDay: null as string | null,
    }),
    computed: {
        vfairData(): VFair | null {
            return this.vfair && this.vfair.data ? this.vfair.data : null;
        },

        currentConfig(): ConferenceDay | null {
            if (!this.config) return null;

            if (!!this.activeDay) {
                const found = this.config.days.find(day => day.videoId === this.activeDay);
                if (!!found) return found;
            }

            for (const day of this.config.days) {
                const date = new Date(day.time);
                if (isSameDay(date, new Date())) return day;
            }
            return this.config.days[0] || null;
        },
    },
    methods: {
        getDayLabel(idx: number, day: ConferenceDay) {
            const dayString = this.$t('vfair.conference.dayN', { n: idx + 1 }).toString();
            const timeString = format(new Date(day.time), 'p');
            return `${dayString} - ${timeString}`;
        },
        checkActiveTab(day: ConferenceDay, idx: number) {
            if (!this.currentConfig) return idx === 0;
            return day.videoId === this.currentConfig.videoId;
        },

        checkForValidFairs() {
            if (
                this.vfairData &&
                !(
                    this.vfairData.id === VFAIR_ID_PROD ||
                    this.vfairData.id === VFAIR_ID_STAGING ||
                    this.vfairData.id === VFAIR_ID_TEST
                )
            )
                this.$router.push(URLS.vfair.concat('/', this.vfairData.id));
        },
        initalize() {
            const vFairId = this.vfairData ? this.vfairData.id : null;
            if (!vFairId) {
                this.isInitialized = true;
                return;
            }

            fetch(`https://content.gethighered.global/vevent/conference/config.json`, {
                method: 'GET',
                headers: {},
            })
                .then(res => res.json())
                .then((config: ConferenceConfig) => (this.config = config))
                .finally(() => (this.isInitialized = true));
        },
    },
    mounted() {
        this.checkForValidFairs();
        this.initalize();
    },
});
